module.exports = __webpack_public_path__ + "img/house-2@2x.13a2d74a.jpg";